// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2tJkz","dragIcon":"SortableItem_dragIcon__3umNw","disabled":"SortableItem_disabled__1XnE8"};